import React, { memo } from 'react';

import { IPrintPartProps } from 'store/entity/IPrintTemplatePart';
import { StringOrNull } from 'store/entity/types';

import messages from './Messages';
import {
  RibbonBoxBody,
  SingleTaskPart,
  RibbonBoxTitle,
  RibbonBoxContainer,
} from '../styles';
import { smartDateString } from '../../../../../utils/date';
// import SanitizedHTML from 'react-sanitized-html';

const FieldPart: React.FC<IPrintPartProps<'fields'>> = ({ item, property }) => {
  let {
    options: { view, size },
  } = item;
  const {
    options: { format },
  } = item;
  const {
    options: { customTitle },
  } = item;
  // for backward compatibility
  if ((view as any) === 'small' || (view as any) === 'large') {
    size = view as any;
    view = 'both';
  }
  const field = property ? property.find((p) => p.name === customTitle) : null;

  const showBothKeyValue = view === 'both';
  let showKey = showBothKeyValue;
  let showValue = showBothKeyValue;

  if (!showBothKeyValue) {
    showKey = view === 'key';
    showValue = view === 'value';
  }

  let fieldName: string | undefined;
  let fieldValue: StringOrNull | undefined;

  if (showKey) {
    fieldName = field?.title || customTitle;
  }
  if (showValue) {
    fieldValue = field ? field.value : messages.fieldIsEmpty;
  }
  if (format === 'date' && fieldValue && fieldValue.length > 0)
    fieldValue = smartDateString(
      Number(fieldValue),
      false,
      true,
      true,
      'jYYYY/jM/jD'
    );

  const html = true; // field ? field.type === 'html' && fieldValue : false;
  return size === 'small' ? (
    <SingleTaskPart>
      {showKey && fieldName && (
        <span>{messages.getFieldsTitle(fieldName, showBothKeyValue)}</span>
      )}
      {showValue && (
        <span>
          {html ? (
            <span dangerouslySetInnerHTML={{ __html: fieldValue || '' }} />
          ) : (
            fieldValue
          )}
        </span>
      )}
    </SingleTaskPart>
  ) : (
    <RibbonBoxContainer>
      <RibbonBoxTitle>{fieldName}</RibbonBoxTitle>
      <RibbonBoxBody>
        {html ? (
          <div
            className="ck"
            dangerouslySetInnerHTML={{ __html: fieldValue || '' }}
          />
        ) : (
          fieldValue
        )}
      </RibbonBoxBody>
    </RibbonBoxContainer>
  );
};

export default memo(FieldPart);
